exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vsko-toolbar {\n    width: 100%;\n    height: 50px;\n    padding: 0 10px;\n}\n\n.vsko-toolbar .vsko-toolbar-right {\n  float: right;\n}\n\n.vsko-toolbar .vsko-toolbar-left {\n  float: left;\n}\n\n.vsko-toolbar-element {\n  padding: 0;\n  float: left;\n}\n\n.vsko-toolbar-text {\n  line-height: 50px;\n  font-size: 14px;\n  margin: 0;\n}\n\n.vsko-toolbar .vsko-toolbar-right .vsko-toolbar-element {\n  padding-left: 10px;\n}\n\n.vsko-toolbar .vsko-toolbar-left .vsko-toolbar-element {\n  padding-right: 10px;\n}\n\n.vsko-toolbar .btn {\n  margin-top: 7px;\n}\n\n.alert-has-toolbar {\n  padding: 0;\n}\n", ""]);

// exports
